module.exports = __webpack_public_path__ + "img/icone-transport.bb54a6ee.svg";